import { DynamicLoaderRegistry, ColorFrom } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';

export interface IFontColorFeature extends IBaseDrawerFeature {
    handleColorChange(value: string, from: ColorFrom | number)
    getModelColor(value);
    getColorSelectButton(): JSX.Element;
}

export const IFontColorFeature = Symbol.for('feature:drawer-font-color');

DynamicLoaderRegistry.merge(IFontColorFeature, {
    useFactory: async () => {
        const { FontColorFeature } = await import('./font-color-feature');
        return FontColorFeature;
    },
    on: loadTask,
});
